<xemex-page-header
  [title]="'“' + searchText() + '”'"
  [subtitle]="
    searchStore.isLoading() ? '' : ('search.resultsCount' | translate: { count: totalResults() })
  "
  [breadcrumbs]="breadcrumbs"
></xemex-page-header>

<xemex-page-body>
  @switch (selectedTab()) {
    @case ('locations') {
      <xemex-locations-content
        [locations]="searchStore.searchs().locations"
        [loading]="searchStore.isLoading()"
      >
        <ng-container *ngTemplateOutlet="tabBar"></ng-container>
      </xemex-locations-content>
    }
    @case ('devices') {
      <xemex-devices-content
        [devices]="searchStore.searchs().devices"
        [loading]="searchStore.isLoading()"
      >
        <ng-container *ngTemplateOutlet="tabBar"></ng-container>
      </xemex-devices-content>
    }
    @case ('installations') {
      <xemex-installations-content
        [installations]="installations()"
        [loading]="searchStore.isLoading()"
      >
        <ng-container *ngTemplateOutlet="tabBar"></ng-container>
      </xemex-installations-content>
    }
    @default {
      <xemex-companies-content
        [partners]="searchStore.searchs().partners"
        [loading]="searchStore.isLoading()"
      >
        <ng-container *ngTemplateOutlet="tabBar"></ng-container>
      </xemex-companies-content>
    }
  }
</xemex-page-body>

<ng-template #tabBar>
  <xemex-tab-bar
    [tabs]="tabs()"
    mode="index"
    [defaultTab]="selectedTabIndex()"
    (tabChange)="onTabChange($event)"
  ></xemex-tab-bar>
</ng-template>
